import { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Popover,
  Tooltip,
} from "antd";
import moment from "moment";
import {
  RiFileExcel2Line,
  RiFilterOffLine,
  RiMailSendLine,
} from "react-icons/ri";
import AutolineNote from "../../components/shared/AutolineNote";
import { BsChevronDown } from "react-icons/bs";
import { Popover as ManPopover } from "@mantine/core";

import MonthlyChart from "./components/MonthlyChart";
import SummaryNumber from "./components/SummaryNumber";
import fetchDataArps from "../../services/fetchDataArps";
import { centers, dummyexpenses } from "../../utils/data";
import PageHeader from "../../components/shared/PageHeader";
import { FiCreditCard } from "react-icons/fi";
import getExpense from "../../utils/getExpense";
import formatMoney from "../../utils/formatMoney";
import ExpenseList from "./components/ExpenseList";

import budget_icon from "../../assets/images/calculator.png";
import expense_icon from "../../assets/images/expenses.png";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../utils/XLSXExport";
import { useSendEmailMutation } from "../../store/endpoints/email/email";
import ComputerWidget from "./components/ComputerWidget";

const { RangePicker } = DatePicker;

export default function AllFinances() {
  const DIAMETER = 60;
  const STROKE_WIDTH = 6;
  const RADIUS = DIAMETER / 2 - STROKE_WIDTH / 2;

  const CIRCUMFERENCE = Math.PI * RADIUS * 2;

  const start = moment().startOf("isoWeek").format("YYYYMMDD");
  const end = moment().endOf("isoWeek").format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [showRange, setShowRange] = useState(false);
  const [expenses, setExpenses] = useState<any>([]);
  const [budgets, setBudgets] = useState<any>([]);
  const [opened, setOpened] = useState(false);
  const [center, setCenter] = useState({
    _id: 1,
    name: "IT Department",
    title: "Information Technology",
    subtitle: "IT Department",
    code: 87,
  });
  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();

  const year = new Date().getFullYear();

  const [form] = Form.useForm();
  const [emailForm] = Form.useForm();

  const handleFetchExpenses = async () => {
    // if (center.code === 87) {
    //   const uri = `finance/transactions/expenses/computer/ungrouped?start=${`${year}0101`}&end=${`${year}1231`}`;
    //   const response = await fetchDataArps(uri);
    //   const data = { _id: 87, list: response?.payload };
    //   setExpenses(data);
    //   return;
    // }
    const uri = `finance/transactions/expenses/centers?center=${
      center.code
    }&start=${`${year}0101`}&end=${`${year}1231`}`;
    const response = await fetchDataArps(uri);
    setExpenses(response?.payload[0]);
  };

  const handleFetchBudgets = async () => {
    const uri = `finance/budget/${center.code}`;
    const response = await fetchDataArps(uri);
    setBudgets(response.payload ? response.payload : []);
  };

  const totalBudget = () => {
    let opex = 0;
    let capex = 0;
    let budget = 0;
    budgets?.butems?.forEach((butem: any) => {
      opex = opex + Number(butem?.opex_amount);
      capex = capex + butem?.total_capex;
      budget = budget + butem?.total_amount;
    });

    const total_opex = isNaN(opex) ? 0 : opex;
    const total_capex = isNaN(capex) ? 0 : capex;
    const total_budget = isNaN(budget) ? 0 : budget;

    return { total_opex, total_capex, total_budget };
  };

  const totalExpenses = () => {
    let total = 0;
    expenses?.list?.forEach((expense: any) => {
      total = total + Number(expense?.base_value);
    });
    return isNaN(total) ? 0 : total;
  };

  const perceUsage = () => {
    const { total_budget } = totalBudget();
    if (total_budget === 0) {
      return 0;
    }
    const amount = totalExpenses() / total_budget;
    return amount;
  };

  const { total_opex } = totalBudget();

  const position = Math.max(1 - perceUsage(), 0);
  const percentage = (perceUsage() * 100).toFixed(1);

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const sendMail = async (values: any) => {
    const data = expenses?.list?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Date: moment(record?.posting_date.toString()).format("Do MMM YYYY"),
        Description: record?.description ? record?.description : "-",

        Narrative: record?.narrative ? record?.narrative : "-",
        Department: record?.department ? record?.department : "-",
        "Cost Center": record?.cost_center ? record?.cost_center : "-",
        Origin: record?.origin ? record?.origin : "-",
        Shortname: record?.shortname ? record?.shortname : "-",
        "Expense Code": record?.expense_code ? record?.expense_code : "-",
        "Journal Reference": record?.journal_reference
          ? record?.journal_reference
          : "-",
        Amount: record?.base_value ? record?.base_value : "-",
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  const onSelectPeriod = (period: any) => {
    if (period?.name === "Weekly") {
      const start = moment().startOf("isoWeek").format("YYYYMMDD");
      const end = moment().endOf("isoWeek").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Monthly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Yearly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    const start = moment().startOf("isoWeek").format("YYYYMMDD");
    const end = moment().endOf("isoWeek").format("YYYYMMDD");
    setStateDate(start);
    setEndDate(end);
  };

  const data =
    expenses === undefined
      ? dummyexpenses
      : getExpense(expenses, budgets, year);

  // const data = expenses === undefined ? dummyexpense : dummyexpense;

  useEffect(() => {
    handleFetchExpenses();
    handleFetchBudgets();
  }, [center]);

  return (
    <div className=" bg-gray-100">
      <AutolineNote />
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <PageHeader
          title={`${center?.name} `}
          subtitle={`Analysis of Budget vs Expenses`}
          tag={`Finances  [ ${year} ]`}
          actions={
            <div className="flex flex-row">
              <div className="flex flex-row items-center">
                <div className="text-white">
                  <ManPopover
                    className="cursor:pointer focus:outline-none bg-red-100  hover:text-white"
                    opened={opened}
                    onClose={() => setOpened(false)}
                    target={
                      <div
                        onClick={() => setOpened((o) => !o)}
                        className="border border-gray-300  py-2 px-2 cursor-pointer"
                      >
                        <div className="flex flex-row justify-between items-center bg-red-100 text-black hover:text-red-800">
                          <div className="flex justify-center items-center">
                            <FiCreditCard />
                            <span className="ml-2 trancate ">
                              {center.name}
                            </span>
                          </div>
                          <div className="ml-2">
                            <BsChevronDown color={"#323232"} />
                          </div>
                        </div>
                      </div>
                    }
                    width={260}
                    position="bottom"
                    withArrow
                  >
                    <div className="flex flex-col">
                      {centers?.map((center: any) => (
                        <button
                          className="cursor-pointer hover:text-toyota text-left focus:outline-none"
                          onClick={() => {
                            setCenter(center);
                            setOpened((o) => !o);
                          }}
                          key={center._id}
                        >
                          {center?.name}
                        </button>
                      ))}
                    </div>
                  </ManPopover>
                </div>
              </div>
            </div>
          }
        />
        <div className="flex justify-between items-center border-b  border-gray-300 py-2 mx-4">
          <div className="flex flex-row justify-between w-full">
            <Form layout="inline" form={form}>
              {showRange ? (
                <div className="flex justify-center items-center">
                  <Form.Item name="ranger">
                    <RangePicker
                      allowClear={true}
                      onChange={onRangeChange}
                      format={"DD-MM-YYYY"}
                    />
                  </Form.Item>

                  <Checkbox onChange={() => setShowRange(!showRange)}>
                    <span className="text-gray-500">Date as Range</span>
                  </Checkbox>
                </div>
              ) : (
                <div className="flex justify-center items-center">
                  <Form.Item name="picker">
                    <DatePicker
                      onChange={onDateChange}
                      format={"DD-MM-YYYY"}
                      placeholder="Specific date"
                    />
                  </Form.Item>
                  <Checkbox onChange={() => setShowRange(!showRange)}>
                    <span className="text-gray-500">Date as Range</span>
                  </Checkbox>
                </div>
              )}
              <Button className="" onClick={() => clearDate()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
            <div className="flex">
              {center.code === 87 ? <ComputerWidget /> : null}
              <Popover
                content={
                  <>
                    <Form
                      name="basic"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      initialValues={{ remember: true }}
                      form={emailForm}
                      onFinish={sendMail}
                      autoComplete="off"
                    >
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                          { required: true, message: "Email is Required" },
                        ]}
                      >
                        <Input placeholder="Email" />
                      </Form.Item>
                      <Form.Item
                        label="Subject"
                        name="subject"
                        rules={[
                          { required: true, message: "Subject is Required" },
                        ]}
                      >
                        <Input placeholder="Email Subject" />
                      </Form.Item>
                      <div className="flex flex-row justify-between">
                        <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                          <Button
                            onClick={() => {
                              toggleMessageModal(false);
                            }}
                          >
                            Cancel
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </>
                }
                title="Message Content"
                trigger="focus"
                placement="left"
                visible={messageModal}
              >
                <Tooltip title="Send Email">
                  <button
                    className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                    onClick={async () => {
                      toggleMessageModal(true);
                    }}
                  >
                    <RiMailSendLine size={21} />
                  </button>
                </Tooltip>
              </Popover>
              <Tooltip title="Export To Excel">
                <button
                  color="#E50000"
                  className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                  onClick={async () => {
                    const data = expenses?.list?.map(
                      (record: any, index: number) => {
                        return {
                          "S/N": index + 1,
                          Date: moment(record?.posting_date.toString()).format(
                            "Do MMM YYYY"
                          ),
                          Description: record?.description
                            ? record?.description
                            : "-",

                          Narrative: record?.narrative
                            ? record?.narrative
                            : "-",
                          Department: record?.department
                            ? record?.department
                            : "-",
                          "Cost Center": record?.cost_center
                            ? record?.cost_center
                            : "-",
                          Origin: record?.origin ? record?.origin : "-",
                          Shortname: record?.shortname
                            ? record?.shortname
                            : "-",
                          "Expense Code": record?.expense_code
                            ? record?.expense_code
                            : "-",
                          "Journal Reference": record?.journal_reference
                            ? record?.journal_reference
                            : "-",
                          Amount: record?.base_value ? record?.base_value : "-",
                        };
                      }
                    );
                    ExportToExcel(data, "Expenses.xlsx");
                  }}
                >
                  <RiFileExcel2Line size={20} />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
          <div className="col-span-12 sm:col-span-9 md:col-span-9">
            <div className="h-full flex flex-col justify-between bg-white border border-gray-300 rounded-lg p-8">
              <div className="grid grid-cols-12 gap-x-3">
                <div className="col-span-12 sm:col-span-12 md:col-span-12">
                  <div className="flex w-full justify-between items-center mb-2">
                    <div className="w-1/3">
                      <div className="font-lobster text-3xl">
                        {center.title}
                      </div>
                      <div className="">Cost Center: {center.code}</div>
                    </div>
                    <div className="flex items-center justify-center w-1/3">
                      <div className="flex flex-col justify-center items-center">
                        <img className="h-8 w-8" src={budget_icon} alt="" />
                        <div
                          style={{ color: "#14488B" }}
                          className="text-2xl font-bold"
                        >
                          Budget
                        </div>
                      </div>
                      <div className="mx-4">Vs</div>
                      <div className="flex flex-col justify-center items-center">
                        <img className="h-8 w-8 " src={expense_icon} alt="" />
                        <div
                          style={{ color: "#A4056B" }}
                          className="text-2xl font-bold"
                        >
                          Actual
                        </div>
                      </div>
                    </div>
                    <div className="w-1/3"></div>
                  </div>
                  <div className="-mt-8 pt-10" style={{ height: 400 }}>
                    <MonthlyChart
                      data={data}
                      center={center}
                      year={"2022"}
                      totalBudget={totalBudget}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-3 md:col-span-3 mt-2 sm:mt-0">
            <div className="h-full bg-white border border-gray-300 rounded-lg">
              <div className="mx-8 mt-4">
                <div className="flex justify-between items-center mt-2 ">
                  <div className="w-3/2 -mt-8">
                    <SummaryNumber
                      title="Operational Budget (Opex)"
                      color={`#14488B`}
                      amount={total_opex}
                    />
                    <SummaryNumber
                      title="Total Expenses"
                      color={`#A4056B`}
                      amount={totalExpenses()}
                    />
                  </div>
                  <div className="flex justify-center items-center">
                    <svg
                      viewBox="0 0 80 80"
                      width="160px"
                      height="160px"
                      className="circle-progress z-0"
                    >
                      <circle
                        cx={DIAMETER / 2}
                        cy={DIAMETER / 2}
                        r={RADIUS}
                        stroke="#A4056B"
                        fill="transparent"
                        strokeWidth={STROKE_WIDTH}
                        style={{
                          strokeDasharray: CIRCUMFERENCE,
                          strokeDashoffset: CIRCUMFERENCE * position,
                        }}
                      />
                    </svg>
                    <div
                      style={{
                        backgroundColor: "#14488B",
                        width: "120px",
                        height: "120px",
                      }}
                      className="w-28 h-28 rounded-full flex justify-center items-center -ml-40 -mt-10"
                    >
                      <div className="w-24 h-24 flex-col rounded-full bg-white flex justify-center items-center">
                        <div className="">Usage</div>
                        <div className="font-bold text-2xl">
                          {percentage}
                          <span className="text-xs">%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mx-8 mb-4 -mt-6 ">
                <div className="border-b"></div>
                <ExpenseList data={data} year={year} center={center} />
                <div className="flex justify-between items-center border-t-2 border-gray-800 py-1">
                  <div className="">Total</div>
                  <div className="text-black">
                    {formatMoney(totalExpenses())}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
